export default __webpack_public_path__ + "static/media/480_store01-jp-web.b7abbd0f.png";